/**
 * @generated SignedSource<<9e5d5f1b724d29b6da6aa4713542db38>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type shopifyAppEmbedBannerMarkActiveMutation$variables = {
  salesChannelID: string;
};
export type shopifyAppEmbedBannerMarkActiveMutation$data = {
  readonly shopifyMarkAppEmbedActive: boolean;
};
export type shopifyAppEmbedBannerMarkActiveMutation = {
  response: shopifyAppEmbedBannerMarkActiveMutation$data;
  variables: shopifyAppEmbedBannerMarkActiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "kind": "ScalarField",
    "name": "shopifyMarkAppEmbedActive",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "shopifyAppEmbedBannerMarkActiveMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "shopifyAppEmbedBannerMarkActiveMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "08d23e5e86ec05a841c598f7ee3e47a6",
    "id": null,
    "metadata": {},
    "name": "shopifyAppEmbedBannerMarkActiveMutation",
    "operationKind": "mutation",
    "text": "mutation shopifyAppEmbedBannerMarkActiveMutation(\n  $salesChannelID: ID!\n) {\n  shopifyMarkAppEmbedActive(salesChannelID: $salesChannelID)\n}\n"
  }
};
})();

(node as any).hash = "f3cb52e9ed3c50da6a01fe2532ff7370";

export default node;
